import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
interface Product {
  name: string;
  price: string;
  image: string;
}
export function Gen3Page() {
  const products: Product[] = [{
    name: 'Gen3-PSS-Gloves USAT',
    price: '$69.00',
    image: 'https://cdn.magicpatterns.com/uploads/niYhHZHhKrMG2frXtC3Vmj/Gen3_PSS-Gloves_USAT.png'
  }, {
    name: 'Gen3 E-Foot Gear',
    price: '$110.84',
    image: 'https://cdn.magicpatterns.com/uploads/cViGkDXcDmPVipYt9uyQmt/Gen3_E-Foot_Gear.jpg'
  }];
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-464">
      <Header data-id="element-465" />

      <main className="flex-grow pt-32 pb-20" data-id="element-466">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-467">
          {/* Page Header */}
          <div className="text-center mb-12" data-id="element-468">
            <h1 className="text-4xl font-black text-gray-900 uppercase tracking-tight mb-4" data-id="element-469">
              <span className="text-red-600" data-id="element-470">GEN 3</span>
            </h1>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-471">
              The newest generation of Daedo electronic scoring gear. Upgrade
              your equipment for the most accurate scoring experience.
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-472">
            {products.map((product, index) => <div key={index} className="flex flex-col items-center bg-white border-4 border-red-600 rounded-2xl p-8 hover:shadow-xl transition-shadow" data-id="element-473">
                {/* Product Image */}
                <div className="w-full aspect-square mb-6 flex items-center justify-center" data-id="element-474">
                  <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain" data-id="element-475" />
                </div>

                {/* Product Name */}
                <h3 className="text-2xl font-black text-gray-900 mb-6 text-center" data-id="element-476">
                  {product.name}
                </h3>

                {/* Quantity and Price Row */}
                <div className="w-full flex items-center justify-between mb-6" data-id="element-477">
                  <div className="flex items-center gap-2" data-id="element-478">
                    <label htmlFor={`qty-${index}`} className="text-lg font-bold text-gray-700" data-id="element-479">
                      Qty
                    </label>
                    <input type="number" id={`qty-${index}`} defaultValue="1" min="1" className="w-20 px-3 py-2 border-2 border-gray-300 rounded text-center text-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-480" />
                  </div>
                  <p className="text-3xl font-black text-gray-900" data-id="element-481">
                    {product.price}
                  </p>
                </div>

                {/* Add to Cart Button */}
                <Button variant="primary" className="w-full !py-3 text-lg bg-red-600 hover:bg-red-700 focus:ring-red-600" data-id="element-482">
                  Add Cart
                </Button>
              </div>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-483" />
    </div>;
}